import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// assessmentInfo-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  checkedPostsAction(store, payload) {
    store.commit('reversedPostsCheck', payload)
  },
  checkedUsersAction(store, payload) {
    store.commit('reversedUsersCheck', payload)
  },
  async setRatesInfos(store, payload) {
    payload[0]['userId'] = master.state.loginUser.adminUserId
    let logContinue = true
    let pageNo = 0
    const count = 1000
    const margeData = {
      data: {
        header: {},
        data: [
          {
            title: {},
            values: []
          }
        ]
      }
    }
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [
          {
            rateConditions: payload,
            pageNo: pageNo,
            count: count
          }
        ]
      }
      var response = await Vue.http.post(
        URL + '/v2/admin/rate/summary',
        data,
        config
      )

      const size = response.data.data[0]['values'].length
      for (let i = 0; i < size; i++) {
        margeData.data.data[0].values.push(response.data.data[0]['values'][i])
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        margeData.data.data[0].title = response.data.data[0]['title']
        logContinue = false
      }
    }

    // 成功
    store.commit('setRatesInfos', margeData)
    store.state.exportFlag = false
  },
  async setUserInfos(store) {
    store.state.users = []
    store.state.posts = []
    let logContinue = true
    let pageNo = 0
    const count = 500
    const margeData = {
      data: {
        header: {},
        data: []
      }
    }
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [
          {
            pageNo: pageNo,
            count: count
          }
        ]
      }
      var response = await Vue.http.post(
        URL + '/v2/admin/rate/userlist',
        data,
        config
      )

      const size = response.data['data'].length
      for (let i = 0; i < size; i++) {
        margeData.data.data.push(response.data['data'][i])
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
    }

    // 成功
    store.commit('setUserInfos', margeData)
  },
  async setPostInfos(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [{}]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/rate/postlist',
      data,
      config
    )
    // 成功
    store.commit('setPostInfos', response)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/assessmentInfoModules/actions.js